import React, { useEffect, useState } from 'react';
import { Table, Button, Row, Col, notification } from 'antd';
import { FaPlusCircle } from "react-icons/fa";
import { getAllPlants, getAllStorage, addStorage } from '../services/PlantsService';

import StorageLocationModalNew from './StorageLocationModalNew';

function StorageLocation(){
  const[dataStorage, setDataStorage] = useState([]);
  const[modalVisibleNew, setModalVisibleNew] = useState(false);
  const[plantId, setPlantId] = useState("");
  const[tableStorageLoading, setTableStorageLoading] = useState(false);

    useEffect(() => {
        setTableStorageLoading(true);
        async function process(){
          const { data } = await getAllPlants();
          setPlantId(data[0].id);
          storage(data[0].id);
        }
        async function storage(id){
            const { data } = await getAllStorage(id);
            setDataStorage(data);
            setTableStorageLoading(false);
          }
        process();
        
    },[])

    const msNotification = (type, title, desc) => {
      notification[type]({
        message: title,
        description:
          desc,
      });
    };

    const handleClickModalNew = () => {
      setModalVisibleNew(true);
    }

    const handleOkModalNew = (data) =>{
      const request = {
        "Name": data.name,
        "Id": data.id
      };
      async function addNew(){
          try {
              const { data } = await addStorage(plantId, request);
              const temp = [...dataStorage];
              temp.push(data);
              setDataStorage(temp);
              msNotification('success', 'Almacén', 'Se creó el Almacén.' );
          } catch (error) {
            msNotification('error', 'Almacén', 'Error al crear el Almacén.' );
          } finally {
            setModalVisibleNew(false);
          }
      }
      addNew();

    }

    const handleCancelModalNew = () =>{
      setModalVisibleNew(false);
    }

    const columns = [
      {
        title: "Información",
        render: (record) => (
          <React.Fragment>
            {record.id}
            <br />
            {record.name}
          </React.Fragment>
        ),
        responsive: ["xs"]
      },
      {
        title: 'ID',
        dataIndex: 'id',
        key: 'id',
        responsive: ["sm"]
      },
      {
        title: 'Nombre',
        dataIndex: 'name',
        key: 'name',
        responsive: ["sm"]
      }
      
    ];

    return(
        <div className="mainContainer">

            <StorageLocationModalNew modalVisibleNew={modalVisibleNew} 
              handleCancelModalNew={handleCancelModalNew}
              handleOkModalNew={handleOkModalNew}
              dataStorage={dataStorage}/>

            <Row>
                <Col span={24}>
                    <h1 className="title">Almacenes</h1>
                    <hr className="hr-title"/>
                </Col>
            </Row>

            <Row className="detailContainer">
                <Col span={24}>
                    <div className="divRight">
                        <Button type="primary" icon={<FaPlusCircle/>} onClick={handleClickModalNew}>
                          &nbsp; Nuevo
                        </Button>
                    </div>
                </Col>
                <Col span={24}>
                    <br/>
                    <Table rowKey="id" dataSource={dataStorage} columns={columns} loading={tableStorageLoading}/>
                </Col>
            </Row>

        </div>
    );
}

export default StorageLocation;



// WEBPACK FOOTER //
// ./src/components/StorageLocation.jsx